import React, { useEffect } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import MicroFrontend from "./MicroFrontend";

import { siteConfig } from './mfe-config';

const { REACT_APP_PATIENT_PORTAL_REMOTE: remoteHost } = process.env;

const ScrollAfterHeroSignup = () => {
  useEffect(() => {
    const SCROLL_TOP = 540;

    if (!window.matchMedia('(max-width: 900px)').matches) return;

    const scroll = () => {
      const containers = [
        document.scrollingElement,
        document.querySelector('#PatientPortalMfe-container'),
        document.querySelector('#root'),
        document.querySelector('main'),
      ].filter(Boolean);

      containers.forEach((el) => {
        el.scrollTo?.({ top: SCROLL_TOP, behavior: 'smooth' });
      });

      window.parentIFrame?.scrollToOffset?.(0, SCROLL_TOP);
    };

    const handleRouteChange = () => {
      if (window.location.pathname.includes('/find-a-provider')) {
        setTimeout(scroll, 1500);
      }
    };

    // catch SPA navigation
    const wrap = (method) => {
      const original = window.history[method];
      window.history[method] = function (...args) {
        const result = original.apply(this, args);
        window.dispatchEvent(new Event('routechange'));
        return result;
      };
      return () => (window.history[method] = original);
    };

    const unwrapPush = wrap('pushState');
    const unwrapReplace = wrap('replaceState');

    window.addEventListener('popstate', handleRouteChange);
    window.addEventListener('routechange', handleRouteChange);

    // initial scroll if already on page
    handleRouteChange();

    return () => {
      unwrapPush();
      unwrapReplace();
      window.removeEventListener('popstate', handleRouteChange);
      window.removeEventListener('routechange', handleRouteChange);
    };
  }, []);

  return null;
};
const Routes = () => (
  <>
    <ScrollAfterHeroSignup />
    <Switch>
      <Route path="/" render={() => (
        <MicroFrontend
          host={remoteHost}
          name="PatientPortalMfe"
          mfeProps={siteConfig}
        />
      )} />
      <Redirect to={{ pathname: '/' }} />
    </Switch>
  </>
);

export default Routes;
